<template>
    <div>
        <div class="form-check">
            <input
            class="form-check-input"
            type="radio"
            name="send_at"
            id="send_at0"
            :value="timeOptions.tomorrowMorning.iso"
            @click="setSendAt(timeOptions.tomorrowMorning.iso)"
            :checked="value === timeOptions.tomorrowMorning.iso">
            <label class="form-check-label" for="send_at0">
            {{ timeOptions.tomorrowMorning.label }}
            </label>
        </div>
        <div class="form-check">
            <input
            class="form-check-input"
            type="radio"
            name="send_at"
            id="send_at1"
            :value="timeOptions.tomorrowAfternoon.iso"
            @click="setSendAt(timeOptions.tomorrowAfternoon.iso)"
            :checked="value === timeOptions.tomorrowAfternoon.iso">
            <label class="form-check-label" for="send_at1">
            {{ timeOptions.tomorrowAfternoon.label }}
            </label>
        </div>
        <div class="form-check">
            <input
            class="form-check-input"
            type="radio"
            name="send_at"
            id="send_at2"
            :value="timeOptions.afterTomorrow.iso"
            @click="setSendAt(timeOptions.afterTomorrow.iso)"
            :checked="value === timeOptions.afterTomorrow.iso">
            <label class="form-check-label" for="send_at2">
            {{ timeOptions.afterTomorrow.label }}
            </label>
        </div>
        <div class="form-check">
            <input
            class="form-check-input"
            type="radio"
            name="send_at"
            id="send_at3"
            :value="timeOptions.afterTomorrow"
            :checked="!Object.values(timeOptions).map(v => v.iso).includes(value) && value">
            <label class="form-check-label" for="send_at3">
            {{ $t('Other date and time') }}
            </label>
        </div>
        <div class="form-group">
          <date-time
            :value="value"
            @input="setSendAt"></date-time>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import DateTime from '@/components/Fields/DateTime'

export default {
  name: 'DelayForm',
  components: {
    DateTime
  },
  props: {
    value: {
      type: String,
      default: null
    }
  },
  data () {
    return {
    }
  },
  computed: {
    timeOptions () {
      const tomorrowMorning = moment().add(1, 'days').set({ hour: 9, minute: 0, second: 0, millisecond: 0 })
      const tomorrowAfternoon = moment().add(1, 'days').set({ hour: 14, minute: 0, second: 0, millisecond: 0 })
      const afterTomorrow = moment().add(2, 'days').set({ hour: 9, minute: 0, second: 0, millisecond: 0 })

      return {
        tomorrowMorning: {
          iso: tomorrowMorning.toISOString(),
          label: this.$t('tomorrow_morning', {
            date: this.$d(tomorrowMorning, 'dayMonthHour')
          })
        },
        tomorrowAfternoon: {
          iso: tomorrowAfternoon.toISOString(),
          label: this.$t('tomorrow_afternoon', {
            date: this.$d(tomorrowAfternoon, 'dayMonthHour')
          })
        },
        afterTomorrow: {
          iso: afterTomorrow.toISOString(),
          label: this.$t('after_tomorrow', {
            date: this.$d(afterTomorrow, 'dayMonthHour'),
            dayWeek: afterTomorrow.locale(this.$i18n.locale).format('dddd')
          })
        }
      }
    }
  },
  created () {
  },
  methods: {
    /*
    setSendAt
    */
    setSendAt (val) {
      this.$emit('input', val)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Parts/DelayForm.vue